// Content load handler
// - Fügt Klassen bei DOMContentLoaded / load hinzu
// - Lazy-load für Elemente mit `data-src`
// - Entfernt optionalen Preloader (#preloader)
// Lazy Loading Handler
// - Lazy-load für Elemente mit `data-src`
// - Verwendet IntersectionObserver für Performance
// - Video-Setup für proxy loading via HTML
// Speichern der gehashten Video-Pfade
let $32a3a3f71f269bc5$var$videoSources = {
    desktop: {},
    mobile: {}
};
function $32a3a3f71f269bc5$var$isImage(el) {
    return el.tagName.toLowerCase() === 'img';
}
function $32a3a3f71f269bc5$var$loadResource(el) {
    return new Promise((resolve)=>{
        if ($32a3a3f71f269bc5$var$isImage(el)) {
            const img = el;
            const src = img.dataset.src;
            if (!src) return resolve();
            img.onload = ()=>img.classList.add('loaded');
            img.onerror = ()=>img.classList.add('error');
            img.src = src;
            delete img.dataset.src;
            return resolve();
        }
        const src = el.getAttribute('data-src');
        if (src) {
            if (el instanceof HTMLIFrameElement) el.src = src;
            else el.setAttribute('style', (el.getAttribute('style') || '') + `background-image:url('${src}')`);
            el.removeAttribute('data-src');
        }
        resolve();
    });
}
function $32a3a3f71f269bc5$export$c3bf910d26c7ca3b() {
    const v = document.getElementById('logoVideo');
    if (!v) return;
    Array.from(v.querySelectorAll('source')).forEach((source)=>{
        const src = source.getAttribute('src');
        const type = source.getAttribute('type') || '';
        if (!src) return;
        const isMobile = source.getAttribute('data-mobile') === 'true';
        if (isMobile) $32a3a3f71f269bc5$var$videoSources.mobile[type] = src;
        else $32a3a3f71f269bc5$var$videoSources.desktop[type] = src;
        // src entfernen, damit Video nicht sofort geladen wird
        source.removeAttribute('src');
    });
}
function $32a3a3f71f269bc5$export$730a095e8e4092e5() {
    const v = document.getElementById('logoVideo');
    if (!v) return;
    const isMobile = window.matchMedia('(max-width:768px)').matches;
    const variant = isMobile ? $32a3a3f71f269bc5$var$videoSources.mobile : $32a3a3f71f269bc5$var$videoSources.desktop;
    Array.from(v.querySelectorAll('source')).forEach((source)=>{
        const type = source.getAttribute('type') || '';
        if (variant[type]) source.setAttribute('src', variant[type]);
    });
    v.load();
    v.autoplay = true;
    v.play().catch(()=>{});
}
function $32a3a3f71f269bc5$export$3b98fa096e9fc203(root = document) {
    return new Promise((resolve)=>{
        const nodes = Array.from(root.querySelectorAll('[data-src]'));
        if (!nodes.length) {
            resolve();
            return;
        }
        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries, obs)=>{
                entries.forEach((entry)=>{
                    if (!entry.isIntersecting) return;
                    const el = entry.target;
                    $32a3a3f71f269bc5$var$loadResource(el).catch(()=>{});
                    obs.unobserve(entry.target);
                });
            }, {
                root: null,
                threshold: 0
            });
            nodes.forEach((n)=>io.observe(n));
            resolve(); // IntersectionObserver Setup fertig
        } else // Fallback: load all immediately
        Promise.all(nodes.map((n)=>$32a3a3f71f269bc5$var$loadResource(n))).then(()=>resolve()).catch(()=>resolve());
    });
}


// Mobile Menu Handler
// - Toggle-Funktionalität für das Hamburger-Menü
// - Backdrop-Handling zum Schließen
// - Smooth Scroll zu Ankern mit Topbar-Offset
function $e745b9ef5c505b0a$var$smoothScrollToTarget(href) {
    // Anchor href auslesen
    if (!href.startsWith('#')) return;
    const targetId = href.substring(1);
    const target = document.getElementById(targetId);
    if (!target) return;
    // Topbar-Höhe ermitteln
    const topbar = document.querySelector('.fuelpipe-topbar');
    const topbarHeight = topbar ? topbar.offsetHeight : 0;
    // Scroll-Position berechnen
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - topbarHeight;
    // Smooth Scroll ausführen
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
}
function $e745b9ef5c505b0a$export$b61d4be8ddba9539() {
    const toggle = document.querySelector('.menu-toggle');
    const backdrop = document.querySelector('.menu-backdrop');
    const navLinks = document.querySelectorAll('.fuelpipe-topbar nav a');
    if (!toggle || !backdrop) return;
    const toggleMenu = ()=>{
        const isOpen = document.body.classList.toggle('nav-open');
        toggle.classList.toggle('active');
        toggle.setAttribute('aria-expanded', String(isOpen));
    };
    toggle.addEventListener('click', (e)=>{
        e.stopPropagation();
        toggleMenu();
    });
    backdrop.addEventListener('click', toggleMenu);
    navLinks.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            const href = link.getAttribute('href');
            // Wenn es ein Anker ist, smooth scroll triggern
            if (href?.startsWith('#')) {
                e.preventDefault();
                $e745b9ef5c505b0a$var$smoothScrollToTarget(href);
            }
            // Menü schließen wenn offen
            if (document.body.classList.contains('nav-open')) toggleMenu();
        });
    });
}


// Scroll Animations Handler
// - Element-basierte Animationen
// - Jedes Element mit [data-animate] triggert unabhängig
// - Respektive auch bei langen Sections früh auslösen
function $b611819413d23cbb$export$4ae6feb6159b4594() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    if (!animatedElements.length) return;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            const element = entry.target;
            const customDelay = parseFloat(element.getAttribute('data-delay') || '0') * 1000; // in ms
            element.style.animationDelay = `${customDelay}ms`;
            element.classList.add('animate-in');
            // Element nach Animation nicht mehr beobachten
            observer.unobserve(element);
        });
    }, {
        threshold: 0.1
    });
    // Alle animierten Elemente beobachten
    animatedElements.forEach((element)=>{
        observer.observe(element);
    });
}


// Scroll Morph Handler
// - Überblendung zwischen .normal und .morph Bildern gekoppelt an Scroll-Fortschritt
// - Beginn: Element in Bildschirmmitte
// - Ende: Element am oberen Rand (minus Topbar-Höhe)
// - Bidirektional: Vorwärts und Rückwärts-Scrollen funktioniert
const $042d2a1a583b6f8f$var$TOPBAR_HEIGHT = 80; // px - CSS @topbar-height
function $042d2a1a583b6f8f$export$4ccdd715a2b7fd1c() {
    const morphContainers = document.querySelectorAll('.foto-morph');
    if (!morphContainers.length) return;
    const configs = Array.from(morphContainers).map((container)=>{
        const morphImg = container.querySelector('img.morph');
        return {
            container: container,
            morphImg: morphImg
        };
    }).filter((config)=>config.morphImg);
    if (!configs.length) return;
    // Update Morph-Opacity kontinuierlich beim Scroll
    const updateMorphOpacity = ()=>{
        configs.forEach(({ container: container, morphImg: morphImg })=>{
            // Bounding Rect vom Container
            const rect = container.getBoundingClientRect();
            const containerCenter = rect.top; // + rect.height / 2;
            const isMobile = window.matchMedia('(max-width:768px)').matches;
            // Viewpoint-Breiten
            const viewportHeight = window.innerHeight;
            const startPoint = isMobile ? viewportHeight * 0.45 - 100 : viewportHeight * 0.45; // Bildschirmmitte
            const endPoint = isMobile ? $042d2a1a583b6f8f$var$TOPBAR_HEIGHT : $042d2a1a583b6f8f$var$TOPBAR_HEIGHT + 100; // Oberer Rand minus Topbar
            // Scroll-Fortschritt berechnen (0 = Start, 1 = Ende)
            // Wenn Container-Mitte in Bildschirmmitte ist: progress = 0
            // Wenn Container-Mitte am oberen Rand ist: progress = 1
            const distanceFromMidpoint = startPoint - containerCenter;
            const activationRange = startPoint - endPoint;
            // Fortschritt clamped zwischen 0 und 1
            let progress = distanceFromMidpoint / activationRange;
            progress = Math.max(0, Math.min(1, progress));
            // Opacity setzen (nur für .morph Bild)
            morphImg.style.opacity = String(progress);
        });
    };
    // Mit requestAnimationFrame für optimale Performance
    const animationLoop = ()=>{
        updateMorphOpacity();
        requestAnimationFrame(animationLoop);
    };
    animationLoop();
}


// Scroll Heading Handler
// - Zerlegt .heading h2 in einzelne Wörter
// - Animiert Wörter einzeln beim Scrollen (blur + skew + opacity)
// - Start: wenn h2 sichtbar wird (unten im Viewport)
// - Ende: wenn h2 oberhalb der Bildschirmmitte
function $0e5e9a9af84e2131$export$c80c5dc5e82459e5() {
    const headings = document.querySelectorAll('.heading h2[data-animate]');
    if (!headings.length) return;
    const configs = Array.from(headings).map((h2)=>{
        const heading = h2.closest('.heading');
        if (!heading) return null;
        const originalText = h2.textContent || '';
        const words = originalText.trim().split(/\s+/);
        // h2 leeren und mit Spans füllen
        h2.innerHTML = '';
        const wordSpans = words.map((word)=>{
            const span = document.createElement('span');
            span.textContent = word;
            span.style.display = 'inline-block';
            span.style.marginRight = '0.3em';
            span.style.willChange = 'filter, transform, opacity';
            h2.appendChild(span);
            return {
                span: span
            };
        });
        return {
            heading: heading,
            h2: h2,
            wordSpans: wordSpans
        };
    }).filter((config)=>config !== null);
    if (!configs.length) return;
    // Update Heading-Animation kontinuierlich beim Scroll
    const updateHeadingAnimation = ()=>{
        configs.forEach(({ heading: heading, wordSpans: wordSpans })=>{
            // Bounding Rect vom Heading
            const rect = heading.getBoundingClientRect();
            const headingCenter = rect.top + rect.height / 2;
            // Viewpoint-Breiten
            const viewportHeight = window.innerHeight;
            // Start: Element kommt unten in Sicht (viewportHeight)
            // Ende: Element ist oberhalb der Bildschirmmitte (viewportHeight / 2)
            const startPoint = viewportHeight; // Unten - Animation beginnt
            const endPoint = viewportHeight / 2; // Mitte - Animation abgeschlossen
            // Fortschritt je näher Element nach oben kommt
            const distanceFromMidpoint = startPoint - headingCenter;
            const activationRange = startPoint - endPoint;
            // Fortschritt clamped zwischen 0 und 1
            let overallProgress = distanceFromMidpoint / activationRange;
            overallProgress = Math.max(0, Math.min(1, overallProgress));
            // Berechne gesamte Stagger-Verzögerung (vom ersten bis letzten Wort)
            const totalWordDelay = (wordSpans.length - 1) * 0.08;
            // Skaliere overallProgress so, dass die Animation über ALLE Wörter läuft
            const adjustedProgress = overallProgress * (1 + totalWordDelay);
            // Für jedes Wort: individueller Fortschritt
            wordSpans.forEach((word, index)=>{
                // Jedes Wort animiert mit Stagger-Effekt
                const wordDelay = index * 0.08; // 8% Stagger pro Wort
                // Fortschritt für dieses Wort (0 bis 1, mit Stagger)
                const wordProgress = Math.max(0, Math.min(1, adjustedProgress - wordDelay));
                // Interpoliere Blur-Effekt
                const blur = 8 * (1 - wordProgress); // Von 8px zu 0px
                const skew = -20 * (1 - wordProgress); // Von -20deg zu 0deg
                const opacity = wordProgress; // Von 0 zu 1
                // CSS anwenden
                word.span.style.filter = `blur(${blur}px)`;
                word.span.style.transform = `skew(${skew}deg)`;
                word.span.style.opacity = String(opacity);
            });
        });
    };
    // Mit requestAnimationFrame für optimale Performance
    const animationLoop = ()=>{
        updateHeadingAnimation();
        requestAnimationFrame(animationLoop);
    };
    animationLoop();
}


// Collapse-Funktionalität für Feature-Boxen
// Toggled die .collapse-Elemente via data-toggle="collapse"
function $a9fb49e667fc6dd8$export$d6a8ee854410e592() {
    const collapseLinks = document.querySelectorAll('[data-toggle="collapse"]');
    collapseLinks.forEach((link)=>{
        // Initiale ARIA-Attribute setzen
        const href = link.getAttribute('href');
        if (href) {
            link.setAttribute('aria-controls', href.substring(1));
            link.setAttribute('aria-expanded', 'false');
        }
        link.addEventListener('click', (e)=>{
            e.preventDefault();
            const currentHref = link.getAttribute('href');
            if (!currentHref) return;
            const targetId = currentHref.substring(1);
            const target = document.getElementById(targetId);
            if (!target) return;
            const isOpen = target.classList.toggle('open');
            // Alle Links, die dasselbe Element steuern, synchronisieren
            collapseLinks.forEach((l)=>{
                if (l.getAttribute('href') === `#${targetId}`) l.setAttribute('aria-expanded', String(isOpen));
            });
        });
    });
}


function $e366f2c43bf887ab$var$removePreloader() {
    const pre = document.getElementById('preloader');
    if (pre && pre.parentNode) pre.parentNode.removeChild(pre);
}
function $e366f2c43bf887ab$var$initHeroAnimation() {
    const teaser = document.getElementById('teaser');
    if (teaser) teaser.classList.add('animate-in');
}
function $e366f2c43bf887ab$var$onDOMContentLoaded() {
    document.documentElement.classList.add('dom-ready');
    document.body.classList.add('dom-ready');
    // LazyLoad zuerst
    (0, $32a3a3f71f269bc5$export$3b98fa096e9fc203)(document);
    // Video-Pfade aus HTML auslesen und speichern
    (0, $32a3a3f71f269bc5$export$c3bf910d26c7ca3b)();
    (0, $e745b9ef5c505b0a$export$b61d4be8ddba9539)();
    // Collapse-Features initialisieren
    (0, $a9fb49e667fc6dd8$export$d6a8ee854410e592)();
    // Öffnungszeiten-Panel Toggle
    const icon = document.querySelector(".opening-hours-icon");
    const panel = document.querySelector("#opening-hours");
    if (icon && panel) {
        const toggleOpening = ()=>{
            const isOpen = panel.classList.toggle("open");
            icon.setAttribute("aria-expanded", String(isOpen));
        };
        icon.addEventListener("click", toggleOpening);
        icon.addEventListener("keydown", (e)=>{
            const ke = e;
            if (ke.key === "Enter" || ke.key === " ") {
                ke.preventDefault();
                toggleOpening();
            }
        });
    }
}
function $e366f2c43bf887ab$var$onWindowLoad() {
    document.documentElement.classList.add('loaded');
    document.body.classList.add('loaded');
    $e366f2c43bf887ab$var$removePreloader();
    // Hero-Animation sofort triggern
    $e366f2c43bf887ab$var$initHeroAnimation();
    // Animationen erst NACH Preloader-Entfernung
    (0, $b611819413d23cbb$export$4ae6feb6159b4594)();
    // Scroll-Morph initialisieren
    (0, $042d2a1a583b6f8f$export$4ccdd715a2b7fd1c)();
    // Scroll-Heading initialisieren
    (0, $0e5e9a9af84e2131$export$c80c5dc5e82459e5)();
    // Video Setup mit richtiger Variante
    (0, $32a3a3f71f269bc5$export$730a095e8e4092e5)();
}
function $e366f2c43bf887ab$export$c1e92a604cbf4acd() {
    if (document.readyState === 'complete') {
        $e366f2c43bf887ab$var$onDOMContentLoaded();
        $e366f2c43bf887ab$var$onWindowLoad();
        return;
    }
    if (document.readyState === 'interactive') {
        $e366f2c43bf887ab$var$onDOMContentLoaded();
        window.addEventListener('load', $e366f2c43bf887ab$var$onWindowLoad, {
            once: true
        });
        return;
    }
    window.addEventListener('DOMContentLoaded', $e366f2c43bf887ab$var$onDOMContentLoaded, {
        once: true
    });
    window.addEventListener('load', $e366f2c43bf887ab$var$onWindowLoad, {
        once: true
    });
}
// Auto-init when module is imported
$e366f2c43bf887ab$export$c1e92a604cbf4acd();


//# sourceMappingURL=drploch_26.e8962a3a.js.map
